<template>
  <div class="notice-page">
    <!-- PC 端 -->
    <div class="notice-pc" v-show="isPC">
      <div class="notice-container">
        <!-- 一、集团简介 -->
        <section class="notice-section">
          <h3>一、集团简介</h3>
          <div class="section-content">
            <p>
              湖北水利发展集团有限公司（简称“湖北水发集团”）是省委、省政府2023年9月批准成立的省属一级国有企业，2024年2月启动组建，8月15日正式揭牌运营。注册资本200亿元，是湖北省级水利基础设施投资、建设、运营、管理主体，是服务支撑全省流域安全、供水安全、江河安澜的主平台。
            </p>
            <p>
              湖北水发集团确立“做强水利基础设施建设运营、做好水资源供给保障、做优水利技术研发应用、做精涉水业务创新发展”四大业务板块布局，构建协同联动格局，打造“基础支撑坚实、增长动能充沛、创新活力迸发”的高质量发展生态，为全面建成“全国一流水资源综合服务商”筑牢坚实业务根基。
            </p>
          </div>
        </section>

        <!-- 二、选聘职数及岗位 -->
        <section class="notice-section">
          <h3>二、选聘职数及岗位</h3>
          <div class="table-wrap">
            <table class="job-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>单位</th>
                  <th>岗位名称</th>
                  <th>职数</th>
                  <th>级别</th>
                  <th>工作地点</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>集团总部</td>
                  <td>科技创新部部长</td>
                  <td>1</td>
                  <td>集团中层正职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>集团总部</td>
                  <td>投资发展部副部长</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>子公司</td>
                  <td>湖北水利发展集团十堰投资开发有限公司总经理</td>
                  <td>1</td>
                  <td>集团中层正职级</td>
                  <td>十堰区域</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>子公司</td>
                  <td>湖北瑞洪工程管理有限公司总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>子公司</td>
                  <td>湖北水发汉江控股有限公司副总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>襄阳区域</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>子公司</td>
                  <td>湖北禹航物产有限责任公司副总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>子公司</td>
                  <td>湖北楚禹水务科技有限公司副总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <!-- 三、招聘要求 -->
        <section class="notice-section">
          <h3>三、招聘要求</h3>
          <div class="sub-title">（一）基本任职条件</div>
          <div class="section-content">
            <p>
              1.
              政治立场坚定，政治素质过硬，坚定拥护“两个确立”、坚决做到“两个维护”，坚决执行党和国家的方针政策，坚持国有企业的社会主义方向。
            </p>
            <p>
              2.
              具有较强的治企能力，善于把握市场经济规律和企业发展规律，掌握宏观经济形势和国家政策法规，有国际视野、战略思维、市场化意识、法治理念，懂经营、会管理、善决策，创新意识和市场竞争意识强，专业素质过硬，工作实绩突出。
            </p>
            <p>
              3.
              具有正确的业绩观，能够完整、准确、全面贯彻新发展理念，正确处理当期效益与长远发展的关系，推动企业全面履行经济责任、政治责任、社会责任。
            </p>
            <p>
              4.
              具有良好的职业操守和个人品行，遵纪守法、诚信经营、廉洁从业、忠于职守、勤勉尽责、务实高效，能够忠实执行企业战略规划和董事会决议，自觉维护企业及股东利益。
            </p>
            <p>
              5.
              熟悉相关法律、行政法规、规章以及其他规范性文件，具有履行职责所必须的专业知识和业务水平。
            </p>
            <p>6. 具有正常履行职责的身体条件。</p>
            <p>7. 有下列情况之一，不得列为拟聘人选：</p>
            <p>（1）无民事行为能力或者限制民事行为能力；</p>
            <p>（2）因犯罪受过刑事处罚的；</p>
            <p>（3）涉嫌违纪违法正在接受审查调查尚未作出结论的；</p>
            <p>
              （4）受到诫勉、组织处理或者处分等影响期未满或者影响期满影响使用的；
            </p>
            <p>
              （5）担任破产清算的公司、企业的董事或者厂长、经理，对该公司、企业的破产负有个人责任的，自该公司、企业破产清算完结之日起未逾三年；
            </p>
            <p>
              （6）担任因违法被吊销营业执照、责令关闭的公司、企业的法定代表人，并负有个人责任的，自该公司、企业被吊销营业执照、责令关闭之日起未逾三年；
            </p>
            <p>（7）被依法列为失信联合惩戒对象的；</p>
            <p>（8）存在其他不宜参加选聘情形的。</p>
          </div>
          <div class="sub-title">（二）基本任职资格</div>
          <div class="section-content">
            <p>
              本次公开选聘具体任职资格详见报名资料中的附件《湖北水发集团2026年度公开选聘中层管理人员任职资格及岗位要求》。
            </p>
          </div>
        </section>

        <!-- 四、薪酬待遇 -->
        <section class="notice-section">
          <h3>四、薪酬待遇</h3>
          <div class="section-content">
            <p>薪资及福利待遇按照集团和各子公司相关制度执行。</p>
          </div>
        </section>

        <!-- 五、报名要求 -->
        <section class="notice-section">
          <h3>五、报名要求</h3>
          <div class="sub-title">（一）报名时间</div>
          <div class="section-content">
            <p>自2026年6月16日起至2026年6月30日17:30截止（逾期不予受理）。</p>
          </div>
          <div class="sub-title">（二）报名方式</div>
          <div class="section-content">
            <p>
              本次选聘仅接受系统报名，不接受其它报名方式，每人限报一个岗位。应聘者按要求填写报名信息，并将相关证明材料[包含但不限于学历学位证书、学信网验证报告（二维码有效期内）、身份证件、任职文件、职称及执业资格证书、能力和业绩证明材料、荣誉获奖证书等]上传至报名系统。
            </p>
          </div>
          <div class="sub-title">（三）报名资料</div>
          <div class="section-content">
            <p>
              报名时须同时上传附件一至附件四的应聘承诺书等资格审查材料，请扫描下方二维码下载。
            </p>
            <div class="qr-code-center">
              <!-- 新增容器 -->
              <img src="../../assets/ewm.png" alt="" />
            </div>
          </div>
        </section>

        <!-- 六、选聘方式及程序 -->
        <section class="notice-section">
          <h3>六、选聘方式及程序</h3>
          <div class="section-content">
            <p>
              主要包括发布选聘公告、简历筛选与资格审查、综合测评、背景调查（外调考察）、体检、研究决定、公示、聘用等。
            </p>
          </div>
        </section>

        <!-- 七、管理方式 -->
        <section class="notice-section">
          <h3>七、管理方式</h3>
          <div class="section-content">
            <p>
              聘任后，按照省委省政府进一步深化国企改革深化提升行动的决策部署，采用“人员管理市场化、业绩考核契约化、薪酬分配差异化、企业管理规范化、人员退出制度化”的方式进行管理。
            </p>
          </div>
        </section>

        <!-- 八、其他事项 -->
        <section class="notice-section">
          <h3>八、其他事项</h3>
          <div class="section-content">
            <p>
              1.
              资格审查贯穿于招聘的全过程。应聘者必须保证本人提交的个人报名信息内容真实、准确，对因个人提供的信息不真实、不准确而导致无法参加综合测评以及其他直接或间接后果的，责任由应聘者自行承担。对应聘者故意提供虚假报名信息，或者在应聘过程中有作弊行为的，一经查实，将取消其应聘资格；已被录用的，取消录用资格。
            </p>
            <p>
              2.
              面试70分以下人员不得列为考察人选。
            </p>
            <p>
              3.
              应聘人员须在招聘期间保持本人手机畅通。对相关通知未在规定时间内回复的，视为自动放弃。凡因应聘人员通信不畅通造成的后果，湖北水发集团不承担责任。各环节未入围者，将不再另行通知。
            </p>
            <p>
              4.
              本次招聘不收取任何费用，不授权任何机构进行培训，请应聘人员提高警惕，谨防受骗。
            </p>
          </div>
        </section>

        <!-- 九、咨询方式 -->
        <section class="notice-section">
          <h3>九、咨询方式</h3>
          <div class="section-content">
            <p>招聘咨询联系人：邓老师 13207151925</p>
            <p>报名系统联系人：潘老师 15623074261</p>
          </div>
        </section>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="notice-mobile" v-show="!isPC">
      <div class="mobile-container">
        <section class="notice-section mobile-section">
          <h3>一、集团简介</h3>
          <div class="section-content">
            <p>
              湖北水利发展集团有限公司（简称“湖北水发集团”）是省委、省政府2023年9月批准成立的省属一级国有企业，2024年2月启动组建，8月15日正式揭牌运营。注册资本200亿元，是湖北省级水利基础设施投资、建设、运营、管理主体，是服务支撑全省流域安全、供水安全、江河安澜的主平台。
            </p>
            <p>
              湖北水发集团确立“做强水利基础设施建设运营、做好水资源供给保障、做优水利技术研发应用、做精涉水业务创新发展”四大业务板块布局，构建协同联动格局，打造“基础支撑坚实、增长动能充沛、创新活力迸发”的高质量发展生态，为全面建成“全国一流水资源综合服务商”筑牢坚实业务根基。
            </p>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>二、选聘职数及岗位</h3>
          <div class="table-wrap">
            <table class="job-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>单位</th>
                  <th>岗位名称</th>
                  <th>职数</th>
                  <th>级别</th>
                  <th>工作地点</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>集团总部</td>
                  <td>科技创新部部长</td>
                  <td>1</td>
                  <td>集团中层正职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>集团总部</td>
                  <td>投资发展部副部长</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>子公司</td>
                  <td>湖北水利发展集团十堰投资开发有限公司总经理</td>
                  <td>1</td>
                  <td>集团中层正职级</td>
                  <td>十堰区域</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>子公司</td>
                  <td>湖北瑞洪工程管理有限公司总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>子公司</td>
                  <td>湖北水发汉江控股有限公司副总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>襄阳区域</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>子公司</td>
                  <td>湖北禹航物产有限责任公司副总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>子公司</td>
                  <td>湖北楚禹水务科技有限公司副总经理</td>
                  <td>1</td>
                  <td>集团中层副职级</td>
                  <td>湖北武汉</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>三、招聘要求</h3>
          <div class="sub-title">（一）基本任职条件</div>
          <div class="section-content">
            <p>
              1.
              政治立场坚定，政治素质过硬，坚定拥护“两个确立”、坚决做到“两个维护”，坚决执行党和国家的方针政策，坚持国有企业的社会主义方向。
            </p>
            <p>
              2.
              具有较强的治企能力，善于把握市场经济规律和企业发展规律，掌握宏观经济形势和国家政策法规，有国际视野、战略思维、市场化意识、法治理念，懂经营、会管理、善决策，创新意识和市场竞争意识强，专业素质过硬，工作实绩突出。
            </p>
            <p>
              3.
              具有正确的业绩观，能够完整、准确、全面贯彻新发展理念，正确处理当期效益与长远发展的关系，推动企业全面履行经济责任、政治责任、社会责任。
            </p>
            <p>
              4.
              具有良好的职业操守和个人品行，遵纪守法、诚信经营、廉洁从业、忠于职守、勤勉尽责、务实高效，能够忠实执行企业战略规划和董事会决议，自觉维护企业及股东利益。
            </p>
            <p>
              5.
              熟悉相关法律、行政法规、规章以及其他规范性文件，具有履行职责所必须的专业知识和业务水平。
            </p>
            <p>6. 具有正常履行职责的身体条件。</p>
            <p>7. 有下列情况之一，不得列为拟聘人选：</p>
            <p>（1）无民事行为能力或者限制民事行为能力；</p>
            <p>（2）因犯罪受过刑事处罚的；</p>
            <p>（3）涉嫌违纪违法正在接受审查调查尚未作出结论的；</p>
            <p>
              （4）受到诫勉、组织处理或者处分等影响期未满或者影响期满影响使用的；
            </p>
            <p>
              （5）担任破产清算的公司、企业的董事或者厂长、经理，对该公司、企业的破产负有个人责任的，自该公司、企业破产清算完结之日起未逾三年；
            </p>
            <p>
              （6）担任因违法被吊销营业执照、责令关闭的公司、企业的法定代表人，并负有个人责任的，自该公司、企业被吊销营业执照、责令关闭之日起未逾三年；
            </p>
            <p>（7）被依法列为失信联合惩戒对象的；</p>
            <p>（8）存在其他不宜参加选聘情形的。</p>
          </div>
          <div class="sub-title">（二）基本任职资格</div>
          <div class="section-content">
            <p>
              本次公开选聘具体任职资格详见报名资料中的附件《湖北水发集团2026年度公开选聘中层管理人员任职资格及岗位要求》。
            </p>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>四、薪酬待遇</h3>
          <div class="section-content">
            <p>薪资及福利待遇按照集团和各子公司相关制度执行。</p>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>五、报名要求</h3>
          <div class="sub-title">（一）报名时间</div>
          <div class="section-content">
            <p>自2026年6月16日起至2026年6月30日17:30截止（逾期不予受理）。</p>
          </div>
          <div class="sub-title">（二）报名方式</div>
          <div class="section-content">
            <p>
              本次选聘仅接受系统报名，不接受其它报名方式，每人限报一个岗位。应聘者按要求填写报名信息，并将相关证明材料[包含但不限于学历学位证书、学信网验证报告（二维码有效期内）、身份证件、任职文件、职称及执业资格证书、能力和业绩证明材料、荣誉获奖证书等]上传至报名系统。
            </p>
          </div>
          <div class="sub-title">（三）报名资料</div>
          <div class="section-content">
            <p>
              报名时须同时上传附件一至附件四的应聘承诺书等资格审查材料，请扫描下方二维码下载。
            </p>
            <div class="qr-code-center">
              <!-- 新增容器 -->
              <img src="../../assets/ewm.png" alt="" />
            </div>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>六、选聘方式及程序</h3>
          <div class="section-content">
            <p>
              主要包括发布选聘公告、简历筛选与资格审查、综合测评、背景调查（外调考察）、体检、研究决定、公示、聘用等。
            </p>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>七、管理方式</h3>
          <div class="section-content">
            <p>
              聘任后，按照省委省政府进一步深化国企改革深化提升行动的决策部署，采用“人员管理市场化、业绩考核契约化、薪酬分配差异化、企业管理规范化、人员退出制度化”的方式进行管理。
            </p>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>八、其他事项</h3>
          <div class="section-content">
            <p>
              1.
              资格审查贯穿于招聘的全过程。应聘者必须保证本人提交的个人报名信息内容真实、准确，对因个人提供的信息不真实、不准确而导致无法参加综合测评以及其他直接或间接后果的，责任由应聘者自行承担。对应聘者故意提供虚假报名信息，或者在应聘过程中有作弊行为的，一经查实，将取消其应聘资格；已被录用的，取消录用资格。
            </p>
            <p>
              2.
              面试70分以下人员不得列为考察人选。
            </p>
            <p>
              3.
              应聘人员须在招聘期间保持本人手机畅通。对相关通知未在规定时间内回复的，视为自动放弃。凡因应聘人员通信不畅通造成的后果，湖北水发集团不承担责任。各环节未入围者，将不再另行通知。
            </p>
            <p>
              4.
              本次招聘不收取任何费用，不授权任何机构进行培训，请应聘人员提高警惕，谨防受骗。
            </p>
          </div>
        </section>

        <section class="notice-section mobile-section">
          <h3>九、咨询方式</h3>
          <div class="section-content">
            <p>招聘咨询联系人：邓老师 13207151925</p>
            <p>报名系统联系人：潘老师 15623074261</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "TabNotice",
  data() {
    return {
      isPC: true,
    };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isPC = window.innerWidth >= 992;
    },
  },
};
</script>
  
  <style scoped lang="less">
.notice-page {
  width: 100%;
  padding: 20px 0;
  background-color: #f9f9f9;
}

/* PC 端样式 */
.notice-pc {
  .notice-container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding: 36px 42px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .notice-section {
      margin-bottom: 36px;

      &:last-child {
        margin-bottom: 0;
      }

      h3 {
        font-size: 20px;
        color: #006699;
        margin: 0 0 14px;
        font-weight: 600;
        display: flex;
        align-items: center;

        &::after {
          content: "";
          flex: 1;
          height: 1px;
          background: #e6eef2;
          margin-left: 16px;
        }
      }

      .sub-title {
        font-size: 16px;
        font-weight: 500;
        color: #005580;
        margin: 10px 0 6px;
      }

      .section-content {
        line-height: 1.85;
        font-size: 15px;
        color: #333;
        text-align: justify;

        p {
          margin-bottom: 14px;
          text-indent: 2em;

          &:last-child {
            margin-bottom: 0;
          }
        }

        // 二维码居中样式
        .qr-code-center {
          display: flex;
          justify-content: center;
          margin: 16px 0; // 可选：增加上下间距，优化视觉
          img {
            width: 200px;
            height: 200px;
            object-fit: contain; /* 防止图片变形 */
          }
        }
      }

      .table-wrap {
        width: 100%;
        overflow-x: auto;
        margin: 12px 0 4px;

        .job-table {
          width: 100%;
          min-width: 700px;
          border-collapse: collapse;

          th,
          td {
            border: 1px solid #e5e5e5;
            padding: 11px 8px;
            text-align: center;
            font-size: 14px;
          }

          th {
            background-color: #006699;
            color: #fff;
            font-weight: 500;
          }

          tbody tr:nth-child(even) {
            background-color: #f7fafc;
          }
        }
      }
    }
  }
}

/* 移动端样式 */
.notice-mobile {
  .mobile-container {
    width: 95%;
    margin: 0 auto;
    background: #fff;
    padding: 22px 16px;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .mobile-section {
      margin-bottom: 28px;

      &:last-child {
        margin-bottom: 0;
      }

      h3 {
        font-size: 17px;
        color: #006699;
        margin: 0 0 10px;
        font-weight: 600;
        display: flex;
        align-items: center;

        &::after {
          content: "";
          flex: 1;
          height: 1px;
          background: #e6eef2;
          margin-left: 12px;
        }
      }

      .sub-title {
        font-size: 15px;
        font-weight: 500;
        color: #005580;
        margin: 8px 0 4px;
      }

      .section-content {
        line-height: 1.8;
        font-size: 14px;
        color: #333;

        p {
          margin-bottom: 12px;
          text-indent: 2em;

          &:last-child {
            margin-bottom: 0;
          }
        }
        // 二维码居中样式
        .qr-code-center {
          display: flex;
          justify-content: center;
          margin: 16px 0; // 可选：增加上下间距，优化视觉
          img {
            width: 200px;
            height: 200px;
            object-fit: contain; /* 防止图片变形 */
          }
        }
      }

      .table-wrap {
        width: 100%;
        overflow-x: auto;
        margin: 8px 0 2px;

        .job-table {
          min-width: 600px;
          border-collapse: collapse;

          th,
          td {
            border: 1px solid #e5e5e5;
            padding: 9px 6px;
            text-align: center;
            font-size: 13px;
          }

          th {
            background-color: #006699;
            color: #fff;
          }

          tbody tr:nth-child(even) {
            background-color: #f7fafc;
          }
        }
      }
    }
  }
}

/* 设备显隐控制 */
@media screen and (max-width: 991px) {
  .notice-pc {
    display: none !important;
  }
}
@media screen and (min-width: 992px) {
  .notice-mobile {
    display: none !important;
  }
}
</style>